import { useEffect, useId } from 'react';
import Icon from './Icons';

export default function AppModal({
  onClose,
  title,
  subtitle,
  ariaLabel,
  children,
  footer = null,
  contentClassName = '',
  headerClassName = '',
  bodyClassName = '',
  footerClassName = '',
  titleClassName = '',
  closeOnOverlay = true,
  closeOnEscape = true,
  showClose = true,
  leadingIcon = null,
}) {
  const generatedId = useId();
  const titleId = title ? `app-modal-title-${generatedId}` : undefined;

  useEffect(() => {
    if (!closeOnEscape || !onClose) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeOnEscape, onClose]);

  const handleOverlayClick = (event) => {
    if (!closeOnOverlay || !onClose) return;
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const shouldRenderHeader = Boolean(title || subtitle || showClose || leadingIcon);

  return (
    <div className="modal-overlay app-modal-overlay" onClick={handleOverlayClick}>
      <div
        className={`modal-content app-modal ${contentClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-label={!title ? ariaLabel : undefined}
        onClick={(event) => event.stopPropagation()}
      >
        {shouldRenderHeader ? (
          <div className={`modal-header app-modal-header ${headerClassName}`.trim()}>
            {(title || subtitle || leadingIcon) ? (
              <div className="app-modal-title-block">
                {leadingIcon ? <span className="app-modal-title-icon">{leadingIcon}</span> : null}
                <div>
                  {title ? <h2 className={`modal-title app-modal-title ${titleClassName}`.trim()} id={titleId}>{title}</h2> : null}
                  {subtitle ? <p className="app-modal-subtitle">{subtitle}</p> : null}
                </div>
              </div>
            ) : <span />}
            {showClose ? (
              <button type="button" className="modal-close app-modal-close" onClick={onClose} aria-label="Close">
                <Icon name="close" size={18} />
              </button>
            ) : null}
          </div>
        ) : null}

        <div className={`app-modal-body ${bodyClassName}`.trim()}>
          {children}
        </div>

        {footer ? (
          <div className={`modal-actions app-modal-actions ${footerClassName}`.trim()}>
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
